module.exports = __webpack_public_path__ + "static/biz-lng-e94de878bbc8a463832c087e787cdc19.jpg";